import * as React from 'react';
import Moment from "moment";
import { IRolePerrmission } from './AccessDomainModels';
import lang from '../Relations/RelationsLang';
import { IConfig } from './IModels';
import { OptionType } from '../ResourcesAutocompleteMI';
import { DatesFieldFormRow, LogDictionaryFormRow, LogEnvironmentFormRow, RolePermissionsMultiFormRow, TextareaFormRow, TextFieldFormRow } from '../Relations/FormsControls';
import { SubRowHeader } from '../Relations/Components';
import { IMultipleEmployeeEditorValue, MultipleEmployeeEditor, isValid } from './MultipleEmployeeEditor';

interface IRolesInputControlState {
	dateError: string,
	permissionRoleError: string,
	descriptionError: string,
	environmentError: string,
	systemNameError: string,
	personAccountTypeError: string,
	companyError: string,
	telephoneError: string,
	emailError: string,
	locationError: string,
	referenceNumberError: string,
	personAccountDescriptionError: string,

	environment: string,
	personAccountDescription: string,
	personAccountType: string,
	company: string,
	telephone: string,
	email: string,
	location: string,
	referenceNumber: string,
	systemName: string,

	selectedFrom: Moment.Moment,
	selectedTo: Moment.Moment,

	description: string,

	selectedRoles: IRolePerrmission[],
	employeesValues: IMultipleEmployeeEditorValue,
}

export interface IRolesInputControlResult {
	from: Moment.Moment;
	to: Moment.Moment;
	systemName: string;
	environment: string;
	telephone: string;
	email: string;
	location: string;
	referenceNumber: string;
	personAccountDescription: string,
	personAccountType: string,
	company: string,

	description: string;
	roles: IRolePerrmission[];
	valuesPerEmployee: IMultipleEmployeeEditorValue;
};

interface IRolesInputControllProps {
	label: string,
	resource: OptionType,
	resourceKind: "Application" | "ServiceAsset",
	selectedEmployees: OptionType[],

	config: IConfig,
}

export class AccessRolesInputControl extends React.Component<IRolesInputControllProps, IRolesInputControlState> {
	constructor(props) {
		super(props);

		this.state = {
			dateError: "",
			permissionRoleError: "",
			descriptionError: "",
			environmentError: "",
			systemNameError: "",
			personAccountTypeError: "",
			companyError: "",
			telephoneError: "",
			emailError: "",
			locationError: "",
			referenceNumberError: "",
			personAccountDescriptionError: "",

			description: "",
			environment: "",
			personAccountDescription: "",
			personAccountType: "",
			company: "",
			telephone: "",
			email: "",
			location: "",
			referenceNumber: "",
			systemName: "",

			selectedFrom: null,
			selectedTo: null,

			selectedRoles: [],

			employeesValues: {},
		};
	}

	public isValidAdd() {
		let fieldsConfig = this.props.config.fields;
		let from = this.state.selectedFrom;
		if (!from) {
			from = Moment({ h: 0, m: 0, s: 0, ms: 0 });
		}

		let to = this.state.selectedTo;

		let result = true;
		let state = {
			dateError: "",
			permissionRoleError: "",
			descriptionError: "",
			environmentError: "",
			systemNameError: "",
			personAccountTypeError: "",
			companyError: "",
			telephoneError: "",
			emailError: "",
			locationError: "",
			referenceNumberError: "",
			personAccountDescriptionError: "",
			employeesValues: this.state.employeesValues,
		};

		var isValidEmployees = isValid(fieldsConfig, state.employeesValues);
		if (!isValidEmployees) {
			result = false;
		};

		if (fieldsConfig.permissionRole.required && this.isApplication()) {

			let roles = this.state.selectedRoles;
			if (!roles || roles.length == 0) {
				let label = lang.getDefaultByPrefix(fieldsConfig.permissionRole, "label", "rolePermissions");
				state.permissionRoleError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if(fieldsConfig.environment.required) {
			if (!this.state.environment) {
				let label = lang.getDefaultByPrefix(fieldsConfig.environment, "label", "environment");
				state.environmentError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.systemName.required) {
			if (!this.state.systemName) {
				let label = lang.getDefaultByPrefix(fieldsConfig.systemName, "label", "systemName");
				state.systemNameError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.personAccountType.required) {
			if (!this.state.personAccountType) {
				let label = lang.getDefaultByPrefix(fieldsConfig.personAccountType, "label", "personAccountType");
				state.personAccountTypeError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.company.required) {
			if (!this.state.company) {
				let label = lang.getDefaultByPrefix(fieldsConfig.company, "label", "company");
				state.companyError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.telephone.required) {
			if (!this.state.telephone) {
				let label = lang.getDefaultByPrefix(fieldsConfig.telephone, "label", "telephone");
				state.telephoneError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.email.required) {
			if (!this.state.email) {
				let label = lang.getDefaultByPrefix(fieldsConfig.email, "label", "email");
				state.emailError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.location.required) {
			if (!this.state.location) {
				let label = lang.getDefaultByPrefix(fieldsConfig.location, "label", "location");
				state.locationError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.referenceNumber.required) {
			if (!this.state.referenceNumber) {
				let label = lang.getDefaultByPrefix(fieldsConfig.referenceNumber, "label", "referenceNumber");
				state.referenceNumberError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.personAccountDescription.required) {
			if (!this.state.personAccountDescription) {
				let label = lang.getDefaultByPrefix(fieldsConfig.personAccountDescription, "label", "personAccountDescription");
				state.personAccountDescriptionError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (to && from > to) {
			state.dateError = "control.relation.fromToErrorMessage";
			result = false;
		}

		if (fieldsConfig.dateTo.required) {
			if (!to) {
				let label = lang.getDefaultByPrefix(fieldsConfig.dateTo, "label", "to");
				state.dateError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.description.required) {
			if (!this.state.description) {
				let label = lang.getDefaultByPrefix(fieldsConfig.description, "label", "description");
				state.descriptionError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (this.state.description.length > 255) {
			let label = lang.getDefaultByPrefix(fieldsConfig.description, "label", "description");
			state.descriptionError = lang.tooLongDescriptionError(label);
			result = false;
		}

		this.setState(state);
		return result;
	}

	getValues(): IRolesInputControlResult {
		let from = this.state.selectedFrom;
		if (!from) {
			from = Moment();
		}

		let to = this.state.selectedTo;
		let roles = this.state.selectedRoles;
		return {
			from: from,
			to: to,
			roles: roles,
			description: this.state.description,
			environment: this.state.environment,
			personAccountDescription: this.state.personAccountDescription,
			personAccountType: this.state.personAccountType,
			company: this.state.company,
			telephone: this.state.telephone,
			email: this.state.email,
			location: this.state.location,
			referenceNumber: this.state.referenceNumber,
			systemName: this.state.systemName,
			valuesPerEmployee: this.state.employeesValues,
		}
	}

	isApplication(): boolean {
		return this.props.resource.kind == "Application";
	}

	render() {
		let fields = this.props.config.fields;

		return <div className="sub-input-row">
			<dl className="form-field">
				<dt>
					<label>{this.props.label}:</label>
				</dt>
				<dd>
					<SubRowHeader>{this.props.resource.label}</SubRowHeader>
					<RolePermissionsMultiFormRow
						config={fields.permissionRole}
						errorText={this.state.permissionRoleError}
						isApplication={this.isApplication()}

						applicationId={parseInt(this.props.resource.value)}
						value={this.state.selectedRoles}
						onSelect={(roles) => this.setState({ selectedRoles: roles })}
					/>

					<MultipleEmployeeEditor
						config={this.props.config}
						resourceId={parseInt(this.props.resource.value)}
						selectedEmployees={this.props.selectedEmployees}
						resourceKind={this.props.resourceKind}

						value={this.state.employeesValues}
						onChange={(v) => this.setState({ employeesValues: v })}

						onChangedLocation={(value) => {

							this.setState({
								location: value,
								locationError: "",
							});
						}}

						onChangedReferenceNumber={(value) => {
							this.setState({
								referenceNumber: value,
								referenceNumberError: "",
							});
						}}
					/>

					<LogEnvironmentFormRow
						name="environment"
						errorText={this.state.environmentError}
						config={fields.environment}
						value={this.state.environment}
						onChange={(value) => this.setState({ environment: value })}
						selectedResource={this.props.resource}
						selectedResourceKind={this.props.resourceKind}
					/>

					<TextFieldFormRow
						name="systemName"
						errorText={this.state.systemNameError}
						config={fields.systemName}
						value={this.state.systemName}
						onChange={(value) => this.setState({ systemName: value })}
					/>

					<LogDictionaryFormRow
						name="personAccountType"
						dictionaryType="PersonAccountType"
						errorText={this.state.personAccountTypeError}
						config={fields.personAccountType}
						value={this.state.personAccountType}
						onChange={(value) => this.setState({ personAccountType: value })}
					/>

					<LogDictionaryFormRow
						name="company"
						dictionaryType="Company"
						errorText={this.state.companyError}
						config={fields.company}
						value={this.state.company}
						onChange={(value) => this.setState({ company: value })}
					/>

					<TextFieldFormRow
						name="telephone"
						errorText={this.state.telephoneError}
						config={fields.telephone}
						value={this.state.telephone}
						onChange={(value) => this.setState({ telephone: value })}
					/>

					<TextFieldFormRow
						name="email"
						errorText={this.state.emailError}
						config={fields.email}
						value={this.state.email}
						onChange={(value) => this.setState({ email: value })}
					/>

					<TextFieldFormRow
						name="location"
						errorText={this.state.locationError}
						config={fields.location}
						value={this.state.location}
						onChange={(value) => this.setState({ location: value })}
					/>

					<TextFieldFormRow
						name="referenceNumber"
						errorText={this.state.referenceNumberError}
						config={fields.referenceNumber}
						value={this.state.referenceNumber}
						onChange={(value) => this.setState({ referenceNumber: value })}
					/>

					<TextareaFormRow
						name="personAccountDescription"
						config={fields.personAccountDescription}
						errorText={this.state.personAccountDescriptionError}
						onChange={value => this.setState({ personAccountDescription: value })}
						value={this.state.personAccountDescription}
					/>

					<DatesFieldFormRow
						editRow={false}
						errorText={this.state.dateError}
						dateFromConfig={fields.dateFrom}
						dateToConfig={fields.dateTo}
						from={this.state.selectedFrom}
						to={this.state.selectedTo}
						onChange={(from, to) => this.setState({ selectedFrom: from, selectedTo: to })}
					/>

					<TextareaFormRow
						name="description"
						errorText={this.state.descriptionError}
						config={fields.description}
						value={this.state.description}
						onChange={(value) => this.setState({ description: value })}
					/>
				</dd>
			</dl>
		</div>
	}
}

